module.exports = __webpack_public_path__ + "img/logo-azul-lineas-negras.e6a24894.png";